<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  app-modal-cancelar-retificacao(
    v-if="showModalRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setor'
    @closeModal="closeRetificacao"
  )
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_RESPONSAVEL",
    @refresh="refresh"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"

    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :infoPrazos="infoPrazos",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro"
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalTrocarResponsavel,
    AppModalCancelarRetificacao
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('ATUALIZACAO_BASE'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      processoTrocado: null,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      showModalRetificacao: false,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      protocolo: null,
      showModalVisualizarProcesso: null,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.ATUALIZACAO_BASE || [],
        filtroResponsavel: filtro?.filtroResponsavel?.ATUALIZACAO_BASE || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 6, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [] },
        { id: 7, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => true },
        {
          id: 8, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Atualizar Base', icone: 'fa-edit', codigo: 'ATUALIZAR_BASE', ordem: 1, show: this.showAtualizarBase, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 3, nome: 'Continuar atualização da Base', icone: 'fa-edit', codigo: 'CONTINUAR_ATUALIZACAO_BASE', ordem: 1, show: this.showContinuarAtualizacaoBase, showToltip: this.showToltipRetificacao, textToltip: this.textToltip },
            { id: 4, nome: 'Revisar Base', icone: 'fa-edit', codigo: 'ATUALIZAR_BASE', ordem: 1, show: this.showRevisarBase, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 4, nome: 'Coninuar revisão da Base', icone: 'fa-edit', codigo: 'CONTINUAR_ATUALIZACAO_BASE', ordem: 1, show: this.showContinuarRevisaoBase, showToltip: this.showToltipRetificacao, textToltip: this.textToltip },
            { id: 5, nome: 'Validar Base', icone: 'fa-edit', codigo: 'VALIDAR_BASE', ordem: 1, show: this.showValidarBase, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 7, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showTrocarResponsavel, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 8, nome: 'Cancelar Retificação', icone: 'fa-times', codigo: 'CANCELAR_RETIFICACAO', ordem: 1, show: this.showCancelarRetificacaoProcessso }
          ]
        }
      ],
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  methods: {
    async ATUALIZAR_BASE (_this, { item }) {
      if (!this.disabledAnalisar) {
        this.disabledAnalisar = true
        if (process.env.ESTADO === 'ap') {
          await _this.executarTramitacao(item.id)
        }
        _this.$router.push({
          name: 'analise/atualizarBase',
          params: {
            idProcesso: item.id,
            acaoCaixa: 'ANALISE'
          }
        })
        this.disabledAnalisar = false
      }
    },
    async CONTINUAR_ATUALIZACAO_BASE (_this, { item }) {
      if (!this.disabledAnalisar) {
        this.disabledAnalisar = true
        _this.$router.push({
          name: 'analise/atualizarBase',
          params: {
            idProcesso: item.id,
            acaoCaixa: 'ANALISE'
          }
        })
        this.disabledAnalisar = false
      }
    },
    async VALIDAR_BASE (_this, { item }) {
      if (!this.disabledAnalisar) {
        this.disabledAnalisar = true
        _this.$router.push({
          name: 'analise/atualizarBase',
          params: {
            idProcesso: item.id,
            acaoCaixa: 'VALIDACAO'
          }
        })
        this.disabledAnalisar = false
      }
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    TROCAR_ANALISTA: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    TROCAR_RESPONSAVEL: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    CANCELAR_RETIFICACAO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
      this.setor = item.setor
      this.showModalRetificacao = true
    },
    closeRetificacao (item) {
      this.showModalRetificacao = false
      this.refresh()
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaAguardandoAtualizacaoBaseListagem.vue